import React from 'react';
import * as Sentry from '@sentry/react';

type Props = {
  children: React.ReactNode;
};

const fallback = (
  <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 p-8">
    <h1 className="text-gray-800 mb-3">Something went wrong</h1>
    <p className="text-gray-600 text-center mb-0">
      An unexpected error occurred. Our team has been notified.
    </p>
  </div>
);

export function SentryErrorBoundary({ children }: Props) {
  return (
    <Sentry.ErrorBoundary fallback={fallback} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
